import { paymentMethodService } from '../../helpers/services/paymentMethod.service'
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  paymentMethods: { data: [] },
  status: { list: true, save: true },
}

export const PAYMENT_METHOD_MODULE = 'paymentMethod'

export const GET_ALL_PAYMENT_METHODS = 'getAllPaymentMethods'
export const CREATE_PAYMENT_METHOD = 'createPaymentMethod'
export const UPDATE_PAYMENT_METHOD = 'updatePaymentMethod'
export const DELETE_PAYMENT_METHOD = 'deletePaymentMethod'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const METHODS_SUCCESS = 'methodsSuccess'

function mapMethod(item) {
  return {
    uuid: item.uuid,
    name: item.name,
    type: item.type,
    // Always an array, so a form can push into it without a guard.
    details: Array.isArray(item.details) ? item.details : [],
    instructions: item.instructions || '',
    imageUrl: item.image_url || null,
    isActive: !!item.is_active,
    sortOrder: item.sort_order ?? 0,
  }
}

export const actions = {
  [GET_ALL_PAYMENT_METHODS]({ commit }, payload) {
    commit(REQUESTING, 'list')
    return paymentMethodService.getAll(payload?.params || {}).then((r) => {
      commit(METHODS_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_PAYMENT_METHOD]({ commit, dispatch }, { data }) {
    commit(REQUESTING, 'save')
    return paymentMethodService.create(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.paymentMethod')]))
      commit(SUCCESS); dispatch(GET_ALL_PAYMENT_METHODS, { params: { include_inactive: 1 } }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [UPDATE_PAYMENT_METHOD]({ commit, dispatch }, { uuid, data }) {
    commit(REQUESTING, 'save')
    return paymentMethodService.update(uuid, data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.paymentMethod')]))
      commit(SUCCESS); dispatch(GET_ALL_PAYMENT_METHODS, { params: { include_inactive: 1 } }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [DELETE_PAYMENT_METHOD]({ commit, dispatch }, { uuid }) {
    return paymentMethodService.remove(uuid).then((r) => {
      commit(SUCCESS); dispatch(GET_ALL_PAYMENT_METHODS, { params: { include_inactive: 1 } }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
}

export const mutations = {
  [METHODS_SUCCESS](state, data) { state.paymentMethods.data = (data.data || []).map(mapMethod) },
  [FAILURE](state) { state.status = { list: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, save: true } },
}
